import { ReactNode } from 'react'

export default function SubContainerWrapper({ children }: { children: ReactNode }): React.ReactElement {
  return (
    <section className="max-w-max grid md:grid-cols-2 xl:grid-cols-1 gap-4 content-start items-start">
      {children}
    </section>
  )
}
